import axios from 'axios';

// Base URL for API requests
// In Create React App, env vars must start with REACT_APP_
// In production on Vercel, leave empty to use same domain (/api/...)
// In development, defaults to localhost:5001

const baseURL = process.env.REACT_APP_API_BASE_URL || 
  (process.env.NODE_ENV === 'development' ? 'http://localhost:5001' : '');

// Helper to handle special endpoints (like Netlify Functions in production)
export async function apiRequest(config) {
  // In production, rewrite to Netlify Functions endpoint
  if (
    process.env.NODE_ENV === 'production' &&
    config.url &&
    config.url.replace(/^\//, '').startsWith('api/admin-deadline')
  ) {
    return axios({
      ...config,
      url: config.url.replace('/api/admin-deadline', '/.netlify/functions/admin-deadline')
    });
  }
  // In development, try /api/admin-deadline (proxy), then fallback to localhost:5001
  if (
    process.env.NODE_ENV === 'development' &&
    config.url &&
    config.url.replace(/^\//, '').startsWith('api/admin-deadline')
  ) {
    try {
      // Try proxy (e.g., setupProxy.js or Vite proxy)
      return await client({ ...config, url: '/api/admin-deadline' });
    } catch (err) {
      // Fallback to direct localhost:5001
      return await axios({
        ...config,
        url: 'http://localhost:5001/api/admin-deadline'
      });
    }
  }
  // Otherwise use the default client
  return client(config);
}

const client = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json'
  }
});

export default client;
